import { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import { baseAxiosNoInfo } from "../../../tool/axios"

export default function () {

    const param: { check_in_id: string } = useParams()

    const [page, setPage] = useState<number>(1)
    const [data, setData] = useState<any[]>([])
    const [showLoadBtn, setShowLoadBtn] = useState<boolean>(true)

    useEffect(() => {
        baseAxiosNoInfo('/cooking_center/customer/dietician_assess/page_list', {
            params: {
                check_in_id: param.check_in_id
            }
        }).then((res: any) => {
            if (res.records.length > 0) {
                let d = data
                setData([...d, ...res.records])

            } else {
                setShowLoadBtn(false)
            }
        })
    }, [])

    return <div className="follow-record">
        {/* 膳食中心 -> 营养膳食 -> 入住客户管理 -> 客户详情 -> 营养评估记录 */}
        {data.length === 0 && '暂无数据'}

        {data.map((el: any) => <ul style={{ listStyle: 'none' }}>
            <li>
                <p className="date">评估日期：{el.assess_date}</p>
            </li>
            <li>
                <p>孕前体重/kg：{el.before_preg_weight}</p>
            </li>
            <li>
                <p>产前体重/kg：{el.before_born_weight}</p>
            </li>
            <li>
                <p>当前体重/kg：{el.current_weight}</p>
            </li>
            <li>
                <p>当前身高/cm：{el.current_height}</p>
            </li>

            <li>
                <p>是否撕裂：{el.has_split_desc}</p>
            </li>
            <li>
                <p>过敏食材名称：{el.guomin_food_item_name}</p>
            </li>
            <li>
                <p>禁忌食材名称：{el.jinji_food_item_name}</p>
            </li>
            <li>
                <p>饮食规律：{el.food_drink_regular_desc}</p>
            </li>

            <li>
                <p>其他：{el.other_exception}</p>
            </li>

            <li>
                <p>喜欢甜食点心：{el.like_sweet_desc}</p>
            </li>
            <li>
                <p>饮水习惯：{el.drink_habit_desc}</p>
            </li>
            <li>
                <p>特殊饮食要求：{el.special_food_drink_desc}</p>
            </li>
            <li>
                <p>膳食补充剂：{el.food_drink_supply_desc}</p>
            </li>
            <li>
                <p>口味偏好描述：{el.taste_flavour_desc}</p>
            </li>

            <li>
                <p>水肿情况：{el.has_shuizhong_desc}</p>
            </li>
            <li>
                <p>排便情况：{el.paibian_status_desc}</p>
            </li>
            <li>
                <p>妊娠合并症：{el.gestation_desc}</p>
            </li>
            <li>
                <p>肠胃病史：{el.stomach_situation_desc}</p>
            </li>
            <li>
                <p>喂养情况：{el.feed_situation_desc}</p>
            </li>
            <li>
                <p>调理需求描述：{el.take_care_needs_desc}</p>
            </li>
            <li>
                <p>营养评估总结：{el.summary}</p>
            </li>
        </ul>)}

        {/* {showLoadBtn  &&  <Button onClick={()=>{
            setPage(page+1)
        }}>加载更多数据</Button>} */}
    </div>
}